import { render, staticRenderFns } from "./EditTypeName.vue?vue&type=template&id=6d375644&scoped=true&"
import script from "./EditTypeName.vue?vue&type=script&lang=js&"
export * from "./EditTypeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d375644",
  null
  
)

export default component.exports